.lockButton {
  display: flex;
}
